import { Pipe, PipeTransform } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { MessageActions } from 'src/app/samwebDescription/samweb/messages/MessageActions';
import { MessageInfo } from 'src/app/store/samwin/samwin-mail-list/message-info';

@Pipe({
   name: 'isMessageActionExecutable$',
})
export class IsMessageActionExecutablePipe implements PipeTransform {
   constructor(private store: Store) {}

   transform(actionId: string, messageInfo: MessageInfo): Observable<boolean> {
      const action: MessageActions = MessageActions[actionId];
      return action.isActionExecutable$(this.store, messageInfo);
   }
}
